import { SettlementDebt } from "../../../models/Entities/SettlementDebt/SettlementDebt";
import { Settlement } from "../../../models/Entities/Settlements/Settlement";
import { ErrorType } from "../../../models/HttpError";
import { AppState } from "../../../redux/reducers";

// stores
import * as SettlementStore from '../../../redux/middleware/SettlementMiddleware';
import * as SettlementDebtsStore from '../../../redux/middleware/SettlementDebtsMiddleware';
import * as CashFlowDebtsStore from '../../../redux/middleware/CashFlow-Debts.Middleware';

interface IProps {
    SettlementId: number;
}
  
  interface ConnectedProps {
    // loaading settlment
    isLoading: boolean;
    failOnLoading: boolean;
    isLoadingSuccessfully: boolean;
    errorLoading: ErrorType | undefined;

    // reconfirm settlement
    isChangingSettlementStatus: boolean;
    failOnChangingSettlementStatus: boolean;
    isChangingSettlementStatusSuccessfully: boolean;
    errorChangingSettlementStatus: ErrorType | undefined;
    
    settlement: Settlement | undefined;
    Debts: SettlementDebt[] | undefined;
  }
  
  interface DispatchProps {
    GetSettlementById: typeof SettlementStore.actionCreators.GetSettlementById;
    ResetSettlementChangeStatusFlags: typeof SettlementStore.actionCreators.ResetSettlementChangeStatusFlags;
    GetSettlementDebtsBySettlementId: typeof SettlementDebtsStore.actionCreators.GetSettlementDebtsBySettlementId;
    GetDebtsBySettlementId: typeof CashFlowDebtsStore.actionCreators.GetDebtsBySettlementId;
  }
  
  export type Props = IProps & ConnectedProps & DispatchProps;
  
  export const mapStateToProps = (state: AppState, ownProps: IProps) => {

    const currentSettlement: Settlement | undefined = state.Settlement?.list?.find((item: Settlement) => item.id === ownProps.SettlementId );
    // derive debts: prefer settlement.debts; fallback to CashFlowDebts payload mapped into SettlementDebt
    const cashflowDebts = (state.CashFlowDebts as any)?.DebtsAsDebtor as any[] | undefined;
    const mappedCashflowDebts: SettlementDebt[] | undefined = cashflowDebts?.map((d: any) => ({
      id: d.id,
      settlementId: ownProps.SettlementId,
      debtId: d.id,
      CashFlowDebt: d
    }));

    return {
            isLoading: currentSettlement?.isGettingDebts || false,
            isLoadingSuccessfully: currentSettlement?.isGettingDebtsSuccess || false,
            failOnLoading: currentSettlement?.failOnGettingDebts || false,
            errorLoading: currentSettlement?.ErrorGettingDebts,

            isChangingSettlementStatus: currentSettlement?.isChangingStatus || false,
            isChangingSettlementStatusSuccessfully: currentSettlement?.successChangingStatus || false,
            failOnChangingSettlementStatus: currentSettlement?.failOnChangeStatus || false,
            errorChangingSettlementStatus: currentSettlement?.ErrorChangingStatus,

            settlement: currentSettlement,
            Debts: currentSettlement?.debts && currentSettlement.debts.length > 0 ? currentSettlement.debts : mappedCashflowDebts,
        }
    };
  
  export const mapDispatchToProps = {
    ...SettlementStore.actionCreators,
    ...SettlementDebtsStore.actionCreators,
    ...CashFlowDebtsStore.actionCreators
  };